class FaqSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-faq-tab]');
    this.panels = this.querySelectorAll('[data-faq-panel]');
    this.init();

    if (this.tabs.length) {
      this.switchTab(this.tabs[0]);
    }

    // Open the first FAQ item in the first visible panel by default
    const firstPanel = this.querySelector('[data-faq-panel]');
    if (firstPanel) {
      const firstItem = firstPanel.querySelector('details.faq__item');
      if (firstItem) firstItem.open = true;
    }

    const content = this.querySelector('.faq__content');
    if (content) content.classList.add('faq__content--initialized');
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });
  }

  switchTab(tab) {
    const handle = tab.dataset.faqTab;

    this.tabs.forEach(t => {
      t.classList.remove('faq__tab--active');
      t.setAttribute('aria-selected', 'false');
    });

    this.panels.forEach(panel => {
      panel.classList.remove('faq__panel--active');
    });

    tab.classList.add('faq__tab--active');
    tab.setAttribute('aria-selected', 'true');

    const panel = this.querySelector(`[data-faq-panel="${handle}"]`);
    if (panel) panel.classList.add('faq__panel--active');
  }
}

customElements.define('faq-section', FaqSection);
